var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountSettingsIcon = function SvgAccountSettingsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.008 11.793c-1.68 0-3.125-1.5-3.125-3.438 0-1.914 1.453-3.375 3.125-3.375s3.125 1.43 3.125 3.36c0 1.953-1.453 3.453-3.125 3.453m-5.242 7.234c-.836 0-1.336-.39-1.336-1.039 0-2.015 2.523-4.797 6.57-4.797 4.055 0 6.578 2.782 6.578 4.797 0 .649-.5 1.04-1.336 1.04z"
  })));
};
export default SvgAccountSettingsIcon;